import { loadable } from '@shared/core/loadableFromNamedExport';

export const LazyLayoutAloha = loadable(() => import(/* webpackChunkName: "content/guest/layouts/aloha" */ './LayoutAloha'), 'LayoutAloha');
